import React, { Fragment } from "react";
import { isBlank, notBlank } from "../../../util/ext";
import { find, includes, is, prop, sortBy } from "ramda";

import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Skeleton from "@material-ui/lab/Skeleton";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";

const MediumFormatSelect = props => {
  const {
    onBlur,
    onChange,
    value,
    mediumFormats,
    required = false,
    error = false,
    helperText = "",
  } = props;

  return (
    <Fragment>
      {mediumFormats.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth>
          <Autocomplete
            id="medium-formats"
            value={value || ""}
            options={sortBy(prop("name"), mediumFormats.data)}
            getOptionLabel={option => {
              if (isBlank(option)) {
                return "";
              } else if (is(Object, option)) {
                return option.display;
              } else {
                const mf = find(
                  l => includes(option, [l.name]),
                  mediumFormats.data,
                );
                return mf.display;
              }
            }}
            onChange={onChange}
            getOptionSelected={(mf, val) =>
              notBlank(val) && mf.name === val.name
            }
            renderInput={params => {
              params.inputProps["aria-autocomplete"] = "none";
              params.inputProps["id"] = "content-mediumFormat";
              return (
                <TextField
                  {...params}
                  required={required}
                  error={error}
                  type="text"
                  onBlur={onBlur}
                  name="content-mediumFormat"
                  label="Medium Format"
                  fullWidth
                />
              );
            }}
          />

          {notBlank(error) && (
            <FormHelperText error>{helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    </Fragment>
  );
};

export default MediumFormatSelect;
